// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vbwM","label":"styles_label__1ifuL"};